import React from "react";
import { Link } from 'react-router-dom';


const Card = ({ style, link, videoSrc, title, description }) => {
  return (
    <Link to={link} target="_blank">
      <div className="card fix-card1" style={style}>
        <video 
          src={videoSrc} 
          width="100%" 
          height="100%" 
          autoPlay 
          loop 
          muted 
          playsInline 
        />
        <div className="card-info"> 
          <p className="card-title">{title}</p>
          <p className="card-description">{description}</p>
        </div>
      </div>
    </Link>
  );
};

export default Card;
